// Calculate 1% of the viewport height
let vh = window.innerHeight * 0.01;
// Set the value in the --vh custom property
document.documentElement.style.setProperty("--vh", `${vh}px`);

// Optionally update on resize
window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});
